 <!-- Header -->
 <div class="col-12 col-sm-12 bgWhite webView"  style="padding: 15px 15px 0px 15px; padding-right: 0px;">
    <div class="col-5 col-sm-5" style="padding: 0px 10px; display: inline-block;">
        <h3 style="display: inline-block;">
            Tags List
        </h3>
    </div>    
    <div class="col-md-7 col-sm-7" style="padding: 0px; display: inline-block; text-align: right;">
        <span class="btn-blue" style="font-size: 13px; display: inline-block; padding: 5px 12px 6px;" (click)="BackTOInvetory()">
            <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
        </span>
    </div>
    <div class="col-md-12 col-12 col-sm-12"  *ngIf="TagsDataArry.length == 0" style="padding: 15px; margin-top: 15px;">
         <div class="NoItemFound" style="cursor: pointer;">No item found</div>
    </div>
</div>
<!-- *ngIf="Items.length == 0"-->

<!-- Display Tags -->

<div class="col-md-12 mainCard" style="padding: 0px 15px;">
    <!-- Right -->
    <div class="col-md-12" style="padding: 15px 0px;">
        <!-- Right -->
        <div class="col-md-5 mainCardHeader inLneBlk" style="padding: 0px; vertical-align:middle;">
                    <div id="divScrID" class="col-md-12" style="padding: 0px;">
                        <div *ngFor="let Tags of TagsDataArry; let i = index" class="col-md-12" style="margin-bottom: 10px;border-radius: 10px;"> 
                            <div class="row" style="color: #e88421; border-radius: 10px; padding: 7px; background: rgba(232,132,33,.09411764705882353);">                                     
                                <div class="col-9">
                                    <span style="font-size: 18px;"> {{Tags.name}} </span>                        
                                </div>       
                                <div class="col-3" style="text-align: right;">
                                    <div style="border-radius: 50%; margin-right: 4px; font-size: 17px;cursor: pointer;" title="delete" (click)="DeleteTags(i)">
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
        </div>
    </div>
</div>